import * as TK from 'components/PDP/Details/components/ProductAccordion/translations/constants';

export const faqCommonLocale = {
  [TK.PRODUCT_DESCRIPTION]: 'About',
  [TK.PRODUCT_DESCRIPTION]: 'About',
  [TK.FLAVORS_BREAKDOWN_WARNING]:
    '<b>Allergen Warning</b>: Edible Arrangements® products contain, or may have come in contact with, tree nuts (almonds, hazelnuts, coconuts, and pistachios), peanuts, wheat, eggs, milk, and soy. We cannot promise that a gift will not have come in contact with nuts, nut oil, or another allergen. We recommend that you take the necessary precautions based on any related allergies.',
  [TK.FLAVORS_BREAKDOWN_VIEW_MORE]: 'View More',
  [TK.FLAVORS_BREAKDOWN_VIEW_LESS]: 'View Less',
  [TK.QUESTIONS]: 'Questions? Ask Away!',
  [TK.COUPONS_APPLICABLE_TITLE]: 'Coupons Not Applicable',
  [TK.ALLERGY_WARNING_TITLE]: 'Allergy Warning: ',
  [TK.DISCLAIMER_TITLE]: 'Disclaimer: ',
};
